import { FilterableMachineAttributes } from './FilterableMachineAttributes'
import { TFilterableMachineAttribute } from './TFilterableMachineAttribute'

export const isValidFilterableMachineAttribute = (
  attribute: string | TFilterableMachineAttribute
): attribute is TFilterableMachineAttribute =>
  Object.values(FilterableMachineAttributes).includes(attribute)
